/*
 * @format
 */

import React from 'react';

import WatchZoneTapDiagram from './WatchZoneTapDiagram';
import { setpointBoxFor } from './WatchFace';

/* The zone screen with the setpoint picked out as the thing to press. */
function WatchSetpointTapDiagram() {
  return (
    <WatchZoneTapDiagram
      boxFor={setpointBoxFor}
      clipId="setpoint-tap-face"
      description={
        'A watch zone screen with the target temperature in the middle ' +
        'highlighted. A line points to a fingertip on it.'
      }
    />
  );
}

export default WatchSetpointTapDiagram;
